"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

require("./sass/link.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Link = function Link(_ref) {
  var children = _ref.children,
      href = _ref.href,
      disabled = _ref.disabled,
      nonDecoration = _ref.nonDecoration;
  var linkClasses = {
    'link-disabled': disabled,
    'link-nonDecoration': nonDecoration
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("a", {
    href: href,
    className: (0, _classnames.default)('link', linkClasses)
  }, children));
};

Link.propTypes = {
  // children: PropTypes.string,
  children: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array]),
  disabled: _propTypes.default.bool,
  href: _propTypes.default.string,
  nonDecoration: _propTypes.default.bool
};
Link.defaultProps = {
  href: '#',
  disabled: false,
  children: 'Add your label',
  nonDecoration: false
};
var _default = Link;
exports.default = _default;